/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the StatsSlotSlotIdImpressionPutRequest interface.
 */
export function instanceOfStatsSlotSlotIdImpressionPutRequest(value) {
    if ((!('userId' in value) && !('UserId' in value)) || (value['userId'] === undefined && value['UserId'] === undefined))
        return false;
    if ((!('startTime' in value) && !('StartTime' in value)) || (value['startTime'] === undefined && value['StartTime'] === undefined))
        return false;
    if ((!('endTime' in value) && !('EndTime' in value)) || (value['endTime'] === undefined && value['EndTime'] === undefined))
        return false;
    if ((!('adReportingId' in value) && !('AdReportingId' in value)) || (value['adReportingId'] === undefined && value['AdReportingId'] === undefined))
        return false;
    return true;
}
export function StatsSlotSlotIdImpressionPutRequestFromJSON(json) {
    return StatsSlotSlotIdImpressionPutRequestFromJSONTyped(json, false);
}
export function StatsSlotSlotIdImpressionPutRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['UserId'],
        'bookingId': json['BookingId'] == null ? undefined : json['BookingId'],
        'startTime': (new Date(json['StartTime'])),
        'endTime': (new Date(json['EndTime'])),
        'adReportingId': json['AdReportingId'],
    };
}
export function StatsSlotSlotIdImpressionPutRequestToJSON(json) {
    return StatsSlotSlotIdImpressionPutRequestToJSONTyped(json, false);
}
export function StatsSlotSlotIdImpressionPutRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'UserId': value['userId'],
        'BookingId': value['bookingId'],
        'StartTime': value['startTime'].toISOString(),
        'EndTime': value['endTime'].toISOString(),
        'AdReportingId': value['adReportingId'],
    };
}
